var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgMenuUp(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M1 4.7L5.5.2c.1-.1.3-.2.5-.2s.4.1.5.2L11 4.7c.3.3.3.8 0 1.1-.3.3-.8.3-1.1 0l-4-4-4 4c-.3.3-.8.3-1 0C.7 5.5.7 5 1 4.7z",
    fill: "#676D7D"
  })));
}
export default SvgMenuUp;